import { useLocation } from 'react-router-dom';
import {
  LOGO_IMAGE,
  OG_IMAGE,
  OG_IMAGE_HEIGHT,
  OG_IMAGE_WIDTH,
  SITE_ORIGIN,
} from '../../content/site.js';

/**
 * Document metadata for the current page. React hoists these tags into head.
 * @param {Object} props
 * @param {string} props.title - Page title
 * @param {string} props.description - Page description
 * @returns {JSX.Element} Hoisted head tags
 */
function Seo({ title, description }) {
  const { pathname } = useLocation();
  const canonical = `${SITE_ORIGIN}${pathname}`;
  const structuredData = JSON.stringify({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: 'Revetall',
        url: `${SITE_ORIGIN}/`,
        email: 'post@revetall.ai',
        logo: LOGO_IMAGE,
        identifier: {
          '@type': 'PropertyValue',
          name: 'Organisasjonsnummer',
          value: '836243382',
        },
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Oslo',
          addressCountry: 'NO',
        },
      },
      {
        '@type': 'WebSite',
        name: 'Revetall',
        url: `${SITE_ORIGIN}/`,
        inLanguage: 'nb',
      },
      {
        '@type': 'WebPage',
        name: title,
        description,
        url: canonical,
        inLanguage: 'nb',
        isPartOf: { '@type': 'WebSite', url: `${SITE_ORIGIN}/` },
      },
    ],
  }).replace(/</g, '\\u003c');

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content={OG_IMAGE_WIDTH} />
      <meta property="og:image:height" content={OG_IMAGE_HEIGHT} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="nb_NO" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      <script type="application/ld+json">{structuredData}</script>
    </>
  );
}

export default Seo;
